export const ASYNC_CREATE_COMPANY = 'ASYNC_CREATE_COMPANY';
export const ASYNC_EDIT_COMPANY = 'ASYNC_EDIT_COMPANY';
export const ASYNC_DELETE_COMPANY = 'ASYNC_DELETE_COMPANY';
export const ASYNC_RESTORE_COMPANY = 'ASYNC_RESTORE_COMPANY';

export const ASYNC_CREATE_COMPANY_RULE = 'ASYNC_CREATE_COMPANY_RULE';
export const ASYNC_EDIT_COMPANY_RULE = 'ASYNC_EDIT_COMPANY_RULE';
export const ASYNC_DELETE_COMPANY_RULE = 'ASYNC_DELETE_COMPANY_RULE';
